import type { CSS } from '../../theme';

export const reset: CSS = {
  boxSizing: 'border-box',
  outline: 'none',
};

export const modalFooter: CSS = {
  position: 'relative',
  fontFamily: '$primary',
  fontSize: '$font75',

  paddingY: '$space200',

  borderBottomLeftRadius: '$xsmall',
  borderBottomRightRadius: '$xsmall',
  borderTop: 'none',

  '@initial': {
    paddingLeft: '$space250',
    paddingRight: '$space250',
  },
  '@small': {
    padding: '$space200',
  },
};

export const modalFooterDefaultActions: CSS = {
  display: 'flex',
  gap: '$space200',

  '@initial': {
    justifyContent: 'space-around',
  },
  '@small': {
    justifyContent: 'flex-end',
  },
};
